// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BHb3","colMin":"styles_colMin__2jLqn"};